<ng-container *ngIf="showSpinner">
  <div class="backdrop spinner-backdrop"></div>
  <div class="wrapper">
    <div class="circle-spinner"></div>
  </div>
</ng-container>

<ng-content></ng-content>
